/** Rows loaded per scroll on listing pages. */
export const LIST_PAGE_SIZE = 10;

/** Replace the list on page 1. Append later pages. */
export function mergeLoadedPage(page, incoming, previous) {
  const rows = Array.isArray(incoming) ? incoming : [];
  if (!page || Number(page) <= 1) return rows;
  const prev = Array.isArray(previous) ? previous : [];
  if (!rows.length) return prev;
  return prev.concat(rows);
}
